<div class="datepicker">
  <EXP__glxy-wrap>
    <ng-container *ngIf="selection === 'single'">
      <mat-form-field [formGroup]="range" appearance="outline">
        <mat-label>
          {{ label || 'GALAXY.DATEPICKER.SELECT_DATE' | translate }}
        </mat-label>
        <input matInput formControlName="start" [matDatepicker]="picker" [max]="maxDate" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="start.hasError('matStartDateInvalid')">
          {{ 'GALAXY.DATEPICKER.INVALID_DATE' | translate }}
        </mat-error>
        <mat-error *ngIf="start.hasError('matDatepickerMax')">
          {{ 'GALAXY.DATEPICKER.MAX_DATE_ERROR' | translate }}
        </mat-error>
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="selection === 'range'">
      <mat-form-field appearance="outline">
        <mat-label>
          {{ label || 'GALAXY.DATE_RANGE.SELECT_DATE_RANGE' | translate }}
        </mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="maxDate">
          <input matStartDate formControlName="start" placeholder="Start date" />
          <input matEndDate formControlName="end" placeholder="End date" [max]="maxDate" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">
          {{ 'GALAXY.DATE_RANGE.ERROR_MESSAGE' | translate }}
        </mat-error>
        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">
          {{ 'GALAXY.DATE_RANGE.ERROR_MESSAGE' | translate }}
        </mat-error>
        <mat-error *ngIf="range.controls.end.hasError('matDatepickerMax')">
          {{ 'GALAXY.DATEPICKER.MAX_DATE_ERROR' | translate }}
        </mat-error>
      </mat-form-field>
    </ng-container>
  </EXP__glxy-wrap>
</div>
